import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useAuthStore } from '../store/authStore'
import { POST_AUTH_REDIRECT_KEY } from '../hooks/useAuth'
import { useState, useRef } from 'react'

let Home_video = ({src = undefined, poster = undefined, brand = undefined}:
  {src?: string, poster?: string, brand?: string})=>{
  let ref = useRef<HTMLVideoElement>(null)
  let [is_play, is_play_set] = useState(false)
  return (
    <div className="group relative rounded-xl sm:rounded-2xl overflow-hidden aspect-[9/16] bg-black shadow-lg hover:shadow-2xl transition-shadow">
      <video ref={ref} src={src} poster={poster} controls={is_play}
        playsInline preload="none" className="w-full h-full object-cover"
        onPlay={()=>is_play_set(true)} onPause={()=>is_play_set(false)}
        onEnded={()=>is_play_set(false)} />
      {!is_play && (
        <button onClick={()=>ref.current?.play()} aria-label="Play video"
          className="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/50 via-black/10 to-transparent cursor-pointer">
          <span className="relative flex items-center justify-center">
            <span className="absolute w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-white/40 animate-ping" />
            <img src="/logo_sponly_color_icon.svg" alt=""
              className="relative w-14 h-14 sm:w-20 sm:h-20 drop-shadow-2xl group-hover:scale-110 transition-transform duration-300" />
          </span>
        </button>
      )}
      {brand && (
        <div className="pointer-events-none absolute top-2 sm:top-3 right-2 sm:right-3 px-2 sm:px-3 py-1 sm:py-1.5 bg-white/95 backdrop-blur-sm rounded-full text-xs font-bold text-gray-900 shadow-lg">
          {brand}
        </div>
      )}
    </div>
  )
}

export default function Home() {
  const navigate = useNavigate()
  const { loginWithRedirect } = useAuth0()
  const { user } = useAuthStore()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handle_signup = () => {
    localStorage.setItem(POST_AUTH_REDIRECT_KEY, 'dashboard')
    loginWithRedirect({authorizationParams: {screen_hint: 'signup'}})
  }

  const handleGetStarted = () => {
    if (user) {
      const userType = user.user_type
      if (userType == 'brand')
        navigate('/brand/dashboard')
      else
        navigate('/creator/dashboard')
      return
    }
    handle_signup()
  }

  let example_videos = ['Coca-Cola', 'Adidas', 'Nike', 'Samsung'].map((brand, i)=>
    ({src: `/home_video${i+1}.mp4`, poster: `/home_video${i+1}.jpg`, brand}))

  return (
    <div className="min-h-screen bg-white">
      {}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md border-b border-gray-200 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {}
            <button
              onClick={() => navigate('/')}
              className="flex items-center"
            >
              <img src="/logo_sponly_color.svg" alt="Sponly" className="h-[28.16px] sm:h-[31.68px] w-auto" />
            </button>
            
            {}
            <div className="hidden md:flex items-center gap-4">
              {user ? (
                <button
                  onClick={handleGetStarted}
                  className="px-6 py-2 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold hover:shadow-lg transition-all"
                >
                  Dashboard
                </button>
              ) : (
                <>
                  <button
                    onClick={() => navigate('/login')}
                    className="px-6 py-2 text-gray-700 hover:text-gray-900 font-semibold transition"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => handle_signup()}
                    className="px-6 py-2 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold hover:shadow-lg transition-all"
                  >
                    Get Started
                  </button>
                </>
              )}
            </div>

            {}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-700"
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={mobileMenuOpen}
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              {user ? (
                <button
                  onClick={() => {
                    handleGetStarted();
                    setMobileMenuOpen(false);
                  }}
                  className="w-full px-4 py-3 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold"
                >
                  Dashboard
                </button>
              ) : (
                <div className="space-y-2">
                  <button
                    onClick={() => {
                      navigate('/login');
                      setMobileMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 text-gray-700 font-semibold text-left hover:bg-gray-50 rounded-lg"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => {
                      handle_signup();
                      setMobileMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold"
                  >
                    Get Started
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </nav>

      {}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-3 sm:px-4 py-2 shadow-sm border border-gray-200 mb-6">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <span className="text-xs sm:text-sm font-semibold text-gray-700">AI-Powered</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Where Brands and
            <span className="block mt-2 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] bg-clip-text text-transparent">
              Creators Meet
            </span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            The brand–creator content marketplace.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <button
              onClick={() => handle_signup()}
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-bold text-base sm:text-lg hover:shadow-xl transition-all"
            >
              Start Free Campaign
            </button>
            <button
              onClick={() => handle_signup()}
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white border-2 border-gray-300 text-gray-700 rounded-xl font-bold text-base sm:text-lg hover:bg-gray-50 transition-all"
            >
              Join as Creator
            </button>
          </div>
        </div>
      </section>

      {}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              See It In Action
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              Real creators, authentic integrations, measurable results
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-5xl mx-auto">
            {example_videos.map((video, idx) => (
              <Home_video key={idx} src={video.src} poster={video.poster}
                brand={video.brand} />
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-12">
            <button
              onClick={() => handle_signup()}
              className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold text-sm sm:text-base hover:shadow-xl transition-all"
            >
              Create Your First Campaign
              <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] bg-clip-text text-transparent mb-2">500M+</div>
              <div className="text-xs sm:text-sm text-gray-600 font-medium">Monthly Views</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] bg-clip-text text-transparent mb-2">10K+</div>
              <div className="text-xs sm:text-sm text-gray-600 font-medium">Active Creators</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] bg-clip-text text-transparent mb-2">500+</div>
              <div className="text-xs sm:text-sm text-gray-600 font-medium">Brands</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] bg-clip-text text-transparent mb-2">98%</div>
              <div className="text-xs sm:text-sm text-gray-600 font-medium">Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {}
      <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
              Simple, fast, and effective brand integration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
            {}
            <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl border border-blue-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#0066FF] to-[#6B4DE6] rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">For Brands</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8">
                Launch campaigns in minutes.
              </p>
              
              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">Upload your brand assets (videos, images)</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">Set targeting and budget</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">Increase brand visibility via creator content</p>
                </div>
              </div>

              <button
                onClick={() => handle_signup()}
                className="w-full px-6 py-3 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white rounded-xl font-semibold text-sm sm:text-base hover:shadow-lg transition-all"
              >
                Launch Campaign →
              </button>
            </div>

            {}
            <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl border border-purple-100">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-[#6B4DE6] to-[#0066FF] rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">For Creators</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8">
                Monetize your content with authentic brand partnerships.
              </p>
              
              <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">Upload your content</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">Choose matching brand campaigns</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-3 h-3 sm:w-4 sm:h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">AI handles integration - get paid</p>
                </div>
              </div>

              <button
                onClick={() => handle_signup()}
                className="w-full px-6 py-3 bg-gradient-to-r from-[#6B4DE6] to-[#0066FF] text-white rounded-xl font-semibold text-sm sm:text-base hover:shadow-lg transition-all"
              >
                Start Earning →
              </button>
            </div>
          </div>
        </div>
      </section>

      {}
      <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#0066FF] to-[#6B4DE6] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 sm:w-96 sm:h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 opacity-90">
            Join thousands of brands and creators already using Sponly.ai
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button
              onClick={() => handle_signup()}
              className="w-full sm:w-auto px-8 sm:px-12 py-3 sm:py-5 bg-white text-[#0066FF] rounded-xl font-bold text-base sm:text-lg hover:shadow-2xl transition-all"
            >
              Get Started Free
            </button>
            <button
              onClick={() => navigate('/login')}
              className="w-full sm:w-auto px-8 sm:px-12 py-3 sm:py-5 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white rounded-xl font-bold text-base sm:text-lg hover:bg-white/20 transition-all"
            >
              Sign In
            </button>
          </div>
        </div>
      </section>

      {}
      <footer className="bg-gray-900 text-white py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8">
            {}
            <div className="flex items-center">
              <img src="/logo_sponly_color.svg" alt="Sponly"
                className="h-[31.68px] w-auto brightness-0 invert" />
            </div>
            
            {}
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm">
              <a href="/legal/privacy" className="text-gray-400 hover:text-white transition">Privacy Policy</a>
              <a href="/legal/terms" className="text-gray-400 hover:text-white transition">Terms of Service</a>
              <a href="/legal/copyright" className="text-gray-400 hover:text-white transition">Copyright Policy</a>
              <a href="mailto:info@sponly.ai" className="text-gray-400 hover:text-white transition">Contact</a>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-6 text-center text-sm text-gray-400">
            © 2026 Sponly.ai. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  )
}